import NonPcnSuggest from '../../NonPcnSuggest';
import { PcnResultTypes } from '@src/utils/enums';
import { commonQuestionData, QuestionDataById } from '@components/dynamic-form/types';
import { getParentObjectV2 } from '../../nonPcnData.types.V2';

export const nonPcnQuestionsById: QuestionDataById = {
  1: {
    sectionId: 1,
    helpInfo:
      'If you are proposing to use multiple NWPs for a single project, please select one at a time and evaluate each NWP separately.',
    question: 'Which Nationwide Permit (NWP) is appropriate to use for your proposed project?',
    questionTypeId: 7,
    endConditions: [
      {
        value: [
          '7',
          '8',
          '17',
          '21',
          '27',
          '29',
          '31',
          '34',
          '37',
          '38',
          '39',
          '40',
          '42',
          '44',
          '45',
          '46',
          '49',
          '50',
          '52',
          '53',
          '54',
          '55',
          '59',
        ],
        comparison: 'contains',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwpGeneralQuestionsById: QuestionDataById = {
  1.1: {
    sectionId: 2,
    question:
      'NWPs 3b, 7, 8, 17, 21, 27, 29, 31, 34, 37, 38, 39, 40, 42, 44, 45, 46, 49, 50, 52, 53, 54, 55, 59 require a PCN for all activities. Go to the [HQ website](https://www.usace.army.mil/Missions/Civil-Works/Regulatory-Program-and-Permits/Nationwide-Permits/) for explanation of all NWPs.',
    questionTypeId: 99,
    parentQuestions: [
      getParentObjectV2(1, 7, 'contains', [
        '3',
        '7',
        '8',
        '17',
        '21',
        '27',
        '29',
        '31',
        '34',
        '37',
        '38',
        '39',
        '40',
        '42',
        '44',
        '45',
        '46',
        '49',
        '50',
        '52',
        '53',
        '54',
        '55',
        '59',
      ]),
    ],
    ...commonQuestionData,
  },
  2: {
    sectionId: 2,
    question: 'Is your project for the resolution of an enforcement action?',
    questionTypeId: 5,
    parentQuestions: [
      getParentObjectV2(1, 7, 'contains', [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '18',
        '19',
        '20',
        '22',
        '23',
        '24',
        '25',
        '28',
        '30',
        '32',
        '33',
        '35',
        '36',
        '41',
        '43',
        '48',
        '51',
        '56',
        '57',
        '58',
        '60',
      ]),
    ],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  3: {
    sectionId: 2,
    question:
      'Does your State have a Joint Permit with the US Army Corps of Engineers which requires submittal of a PCN for NWPs?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(2, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  4: {
    sectionId: 2,
    helpInfo:
      'General Condition 18. No activity is authorized under any NWP which “may affect” a listed species or critical habitat, unless ESA section 7 consultation addressing the consequences of the proposed activity on listed species or critical habitat has been completed. Non-federal permittees must submit a pre-construction notification to the district engineer if any listed species (or species proposed for listing) or designated critical habitat (or critical habitat proposed such designation) might be affected or is in the vicinity of the activity, or if the activity is located in designated critical habitat or critical habitat proposed for such designation. The following links with species range and critical habitat information are provided to assist with screening whether a proposed activity site may be in the vicinity of a species range or critical habitat: [USFWS IPaC](https://ecos.fws.gov/ipac/) and [NOAA NMFS Critical Habitat Mapper](https://noaa.maps.arcgis.com/apps/webappviewer/index.html?id=68d8df16b39c48fe9f60640692d0e318)',
    question:
      'Is a federally listed species (or species proposed for listing) or federally designated critical habitat (or habitat proposed for such designation) located in the vicinity of the proposed activity, or might the proposed activity affect a listed species (or species proposed for listing) or federally designated critical habitat (or habitat proposed for such designation)?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(3, 5, '=', 'NO')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  4.1: {
    sectionId: 2,
    helpInfo:
      'The permittee is the person or organization that will carry out the proposed activity and be responsible for complying with all the terms and conditions of the NWP. A federal agency is the permittee when the federal agency would carry out the proposed activity (or have the activity completed on its behalf) and will be responsible for complying with all the terms and conditions of the NWP. For the purposes of this question, a state agency is considered a federal permittee under General Condition 18 of the Nationwide Permit program when that state agency has assumed the Secretary of Transportation’s responsibilities for Section 106 NHPA compliance under 23 U.S.C. 327 or 23 U.S.C. 326 for the given activity and will carry out the proposed activity. The federal permittee is responsible for fulfilling its obligation to comply with the Endangered Species Act. Non-federal Permittees are all other applicants, including but not limited to: individuals, state or local governments, tribes, companies, corporations, or other organizations. Non-federal permittees whose activities are funded by federal agencies are not considered federal permittees under the Nationwide Permit program, with the exception of state agencies that have assumed the Secretary of Transportation’s environmental review responsibilities for a given activity pursuant to 23 U.S.C. 327 or 23 U.S.C. 326.',
    question:
      'Would a federal agency (or a state agency that assumed the Secretary of Transportation’s Section 106 NHPA compliance responsibilities for the activity pursuant to 23 U.S.C. 327 or 23 U.S.C. 326) be the permittee?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(4, 7, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  5: {
    sectionId: 2,
    helpInfo:
      'General Condition 20. No activity is authorized under any NWP which may have the potential to cause effects to properties listed, or eligible for listing, in the National Register of Historic Places until the requirements of Section 106 of the National Historic Preservation Act (NHPA) have been satisfied.',
    question:
      'Might the activity have the potential to cause effects to any historic property listed on, determined to be eligible for listing on, or potentially eligible for listing on the National Register of Historic Places, including previously unidentified properties?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(4, 7, '=', 'NO'), getParentObjectV2(4.1, 7, '=', 'YES')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  5.1: {
    sectionId: 2,
    helpInfo:
      'The permittee is the person or organization that will carry out the proposed activity and be responsible for complying with all the terms and conditions of the NWP. A federal agency is the permittee when the federal agency would carry out the proposed activity (or have the activity completed on its behalf) and will be responsible for complying with all the terms and conditions of the NWP. For the purposes of this question, a state agency is considered a federal permittee under General Condition 20 of the Nationwide Permit program when that state agency has assumed the Secretary of Transportation’s responsibilities for Section 106 NHPA compliance under 23 U.S.C. 327 or 23 U.S.C. 326 for the given activity and will carry out the proposed activity. The federal permittee is responsible for fulfilling its obligation to comply with the National Historic Preservation Act.Non-federal Permittees are all other applicants, including but not limited to: individuals, state or local governments, tribes, companies, corporations, or other organizations. Non-federal permittees whose activities are funded by federal agencies are not considered federal permittees under the Nationwide Permit program, with the exception of state agencies that have assumed the Secretary of Transportation’s environmental review responsibilities for a given activity pursuant to 23 U.S.C. 327 or 23 U.S.C. 326.',
    question:
      'Would a federal agency (or a state agency that assumed the Secretary of Transportation’s Section 106 NHPA compliance responsibilities for the activity pursuant to 23 U.S.C. 327 or 23 U.S.C. 326) be the permittee?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(5, 7, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  6: {
    sectionId: 2,
    question: 'Will the activity take place in a component of the National Wild and Scenic River System?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(5, 7, '=', 'NO'), getParentObjectV2(5.1, 7, '=', 'YES')],
    endConditions: [
      {
        value: 'Yes',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  8: {
    sectionId: 2,
    question:
      'Will the activity alter or temporarily or permanently occupy or use a federally authorized USACE Civil Works project?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(6, 7, '=', 'NO')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  9: {
    sectionId: 2,
    question: 'Does the activity require a waiver of any NWP terms?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(8, 7, '=', 'NO')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  10: {
    sectionId: 2,
    helpInfo: `Review Regional Conditions on the [District's website](https://regulatory.ops.usace.army.mil/offices/).`,
    question: "Does the activity meet the local District's Regional Conditions for the applicable NWP?",
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(9, 7, '=', 'NO')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  10.1: {
    sectionId: 2,
    question: 'Do any of the Regional Conditions require a PCN for your project?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObjectV2(10, 7, '=', 'YES')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};

const nwp1QuestionsById: QuestionDataById = {
  11: {
    sectionId: 3,
    question:
      'Will the project involve the placement of aids to navigation and regulatory markers in Section 10 waters that are approved by and installed in accordance with the requirements of the U.S. Coast Guard?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '1'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp2QuestionsById: QuestionDataById = {
  12: {
    sectionId: 4,
    question:
      'Will the project involve structures constructed in artificial canals within principally residential developments where the connection of the canal to a navigable water of the United States has been previously authorized?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '2'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp3QuestionsById: QuestionDataById = {
  13: {
    sectionId: 5,
    helpInfo:
      "Minor deviations in the structure's configuration or filled area, including those due to changes in materials, construction techniques, requirements of other regulatory agencies, or current construction codes or safety standards that are necessary to make the repair, rehabilitation, or replacement are authorized.",
    question:
      'Will the project involve the repair, rehabilitation, or replacement of any previously authorized, currently serviceable structure or fill, or of any currently serviceable structure or fill authorized by 33 CFR 330.3, provided that the structure or fill is not to be put to uses differing from those uses specified or contemplated for it in the original permit or the most recently authorized modification?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '3'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    ...commonQuestionData,
  },
  13.1: {
    sectionId: 5,
    question:
      "Will the project involve no change or only minor deviations in the structure's configuration or filled area?",
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(13, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  13.2: {
    sectionId: 5,
    helpInfo:
      'Any stream channel modification is limited to the minimum necessary for the repair, rehabilitation, or replacement of the structure or fill; such modifications, including the removal of material from the stream channel, must be immediately adjacent to the project.',
    question:
      'If any stream channel modification is proposed, will it be limited to the minimum necessary for the repair, rehabilitation, or replacement of the structure or fill?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(13.1, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    requireAllParents: true,
    ...commonQuestionData,
  },
  14: {
    sectionId: 5,
    question: 'Will the project involve removal of previously authorized structures or fills?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(13.2, 5, '=', 'YES'), getParentObjectV2(13, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  15: {
    sectionId: 5,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    question:
      'If the project involves the removal of accumulated sediment and debris, is all removal within within the immediate vicinity of the structure or fill?',
    questionTypeId: 7,
    parentQuestions: [getParentObjectV2(14, 5, 'exists', '')],
    ...commonQuestionData,
  },
  16: {
    sectionId: 5,
    question:
      'Will the project involve the repair, rehabilitation, or replacement of those structures or fills destroyed or damaged by storms, floods, fire or other discrete events?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(15, 7, 'exists', '')],
    ...commonQuestionData,
  },
  17: {
    sectionId: 5,
    helpInfo:
      'In cases of catastrophic events, such as hurricanes or tornadoes, this two-year limit may be waived by the district engineer, provided the permittee can demonstrate funding, contract, or other similar delays.',
    question:
      'Will the repair, rehabilitation, or replacement commence or be under contract to commence within 2 years of the date of destruction or damage?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(16, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  18: {
    sectionId: 5,
    helpInfo:
      'Appropriate measures must be taken to maintain normal downstream flows and minimize flooding to the maximum extent practicable, when temporary structures, work, and discharges of dredged or fill material, including cofferdams, are necessary for construction activities, access fills, or dewatering of construction sites. Temporary fills must consist of materials, and be placed in a manner, that will not be eroded by expected high flows. After conducting the maintenance activity, temporary fills must be removed in their entirety and the affected areas returned to pre-construction elevations. The areas affected by temporary fills must be revegetated, as appropriate.',
    question:
      'Will the project involve temporary structures, fills, and work, including the use of temporary mats, necessary to conduct the maintenance activity?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(16, 5, '=', 'NO'), getParentObjectV2(17, 5, '=', 'YES')],
    ...commonQuestionData,
  },
  18.1: {
    sectionId: 5,
    question:
      'Will the project involve maintenance dredging for the primary purpose of navigation, beach restoration, new stream channelization or stream relocation projects?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(18, 5, 'exists', '')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp4QuestionsById: QuestionDataById = {
  19: {
    sectionId: 6,
    helpInfo:
      'This NWP does not authorize artificial reefs or impoundments and semi-impoundments of waters of the United States for the culture or holding of motile species such as lobster, or the use of covered oyster trays or clam racks.',
    question:
      'Will the project involve fish and wildlife harvesting devices and activities such as pound nets, crab traps, crab dredging, eel pots, lobster traps, duck blinds, and clam and oyster digging, fish aggregating devices, and small fish attraction devices such as open water fish concentrators (sea kites, etc.)?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '4'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  19.1: {
    sectionId: 6,
    question:
      'Does the project involve artificial reefs or impoundments and semi-impoundments of waters of the United States for the culture or holding of motile species such as lobster, or the use of covered oyster trays or clam racks?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(19, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp5QuestionsById: QuestionDataById = {
  20: {
    sectionId: 7,
    question:
      'Will the project involve devices, whose purpose is to measure and record scientific data, such as staff gages, tide and current gages, meteorological stations, water recording and biological observation devices, water quality testing and improvement devices, and similar structures?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '5'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    ...commonQuestionData,
  },
  21: {
    sectionId: 7,
    question:
      'Upon completion of the use of the device to measure and record scientific data, will the measuring device and any other structures or fills associated with that device be removed to the maximum extent practicable and the site restored to pre-construction elevations?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(20, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  22: {
    sectionId: 7,
    question:
      'Will the project involve small weirs and flumes constructed primarily to record water quantity and velocity?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(20, 5, '=', 'NO'), getParentObjectV2(21, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  23: {
    sectionId: 7,
    question: 'Is the fill material associated with the weirs or flumes limited to 25 cubic yards?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(22, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp6QuestionsById: QuestionDataById = {
  24: {
    sectionId: 8,
    helpInfo:
      'The discharge of drilling mud and cuttings may require a permit under Section 402 of the Clean Water Act.',
    question:
      'Will the project involve survey activities, such as core sampling, seismic exploratory operations, plugging of seismic shot holes and other exploratory-type bore holes, exploratory trenching, soil surveys, sampling, sample plots or transects for wetland delineations, and historic resources surveys?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '6'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  25: {
    sectionId: 8,
    helpInfo:
      'For the purposes of this NWP, the term "exploratory trenching" means mechanical land clearing of the upper soil profile to expose bedrock or substrate, for the purpose of mapping or sampling the exposed material.',
    question: 'Will the project involve an exploratory trench?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(24, 5, '=', 'YES')],
    ...commonQuestionData,
  },
  25.1: {
    sectionId: 8,
    question:
      'Will the area be restored to its preconstruction elevation upon completion of the work and designed to not drain a water of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(25, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  26: {
    sectionId: 8,
    question: 'Will the top 6-12 inches of the trench be backfilled with soil from the trench?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(25.1, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  27: {
    sectionId: 8,
    question: 'Will the project involve the construction of a temporary pad associated with the survey activities?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(25, 5, '=', 'NO'), getParentObjectV2(26, 5, '=', 'YES')],
    ...commonQuestionData,
  },
  28: {
    sectionId: 8,
    question: 'Will the temporary pad impact more than 1/10 acre of waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(27, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  29: {
    sectionId: 8,
    question:
      'Will the project involve the discharge of dredged or fill material in waters of the United States associated with the recovery of historic resources?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(27, 5, '=', 'NO'), getParentObjectV2(28, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  30: {
    sectionId: 8,
    question:
      'Will the project involve the discharge of dredged or fill material in waters of the United States associated with the drilling and the discharge of excavated material from test wells for oil and gas exploration?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(29, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  31: {
    sectionId: 8,
    question: 'Will the project involve plugging test wells used for oil and gas exploration?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(30, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  32: {
    sectionId: 8,
    question:
      'Will the project involve the discharge of dredged or fill material in waters of the United States associated with roads or other similar activities?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(31, 5, '=', 'YES'), getParentObjectV2(31, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  33: {
    sectionId: 8,
    question: 'Will the project involve permanent structures?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(32, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp9QuestionsById: QuestionDataById = {
  34: {
    sectionId: 9,
    question:
      'Will the project involve structures, buoys, floats, and other devices placed within anchorage or fleeting areas in Section 10 waters to facilitate moorage of vessels where such areas have been established for that purpose?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '9'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp10QuestionsById: QuestionDataById = {
  35: {
    sectionId: 10,
    question: 'Will the project involve non-commercial, single-boat, mooring buoys in Section 10 waters?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '10'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp11QuestionsById: QuestionDataById = {
  36: {
    sectionId: 11,
    helpInfo:
      'Events include waterskiing competitions, boat races, or seasonal use. At USACE reservoirs, the reservoir managers must approve each buoy or marker individually.',
    question:
      'Will the project involve temporary buoys, markers, small floating docks, and similar structures placed for recreational use during specific events?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '11'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  37: {
    sectionId: 11,
    question: 'Will the structures be removed within 30 days after use is discontinued?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(36, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp12QuestionsById: QuestionDataById = {
  38: {
    sectionId: 12,
    helpInfo:
      'An “oil or natural gas pipeline” is defined as any pipe or pipeline for the transportation of any form of oil or natural gas, including products derived from oil or natural gas, such as gasoline, jet fuel, diesel fuel. heating oil, petrochemical feedstocks, waxes, lubricating oils, and asphalt.',
    question:
      'Will the project involve the construction, maintenance, repair, and removal of oil and natural gas pipelines and associated facilities in waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '12'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    ...commonQuestionData,
  },
  39: {
    sectionId: 12,
    question:
      'Will the discharge of dredged or fill material cause the loss of more than 0.1 acre of waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(38, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  40: {
    sectionId: 12,
    question:
      'Will the project involve work in, over or under a Navigable Water of the United States (i.e. Section 10 waters)?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(39, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  41: {
    sectionId: 12,
    question: 'Is the impact to waters of the United States for the construction of a pipeline?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(40, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  41.1: {
    sectionId: 12,
    question:
      'Is the proposed pipeline activity associated with an overall project that is greater than 250 miles in length and the project purpose is to install new pipeline (vs. conduct repair or maintenance activities) along the majority of the distance of the overall project length?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(41, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  42: {
    sectionId: 12,
    question: 'Will the pipeline result in changes to pre-construction contours of waters of the United States?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObjectV2(41.1, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  43: {
    sectionId: 12,
    question:
      'If the project is associated with the construction of a pipeline and requires a trench, will the material be sidecast into waters of the United States?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObjectV2(42, 7, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  44: {
    sectionId: 12,
    helpInfo:
      'In wetlands, the top 6 to 12 inches of the trench should normally be backfilled with topsoil from the trench.',
    question: 'Will material sidecast into waters of the United States be removed within 3 months of placement?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(43, 7, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  45: {
    sectionId: 12,
    helpInfo:
      'Any exposed slopes and stream banks must be stabilized immediately upon completion of the utility line crossing of each waterbody.',
    question: 'Will the trench be constructed or backfilled in a manner that drains waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(43, 7, '=', 'NO'), getParentObjectV2(44, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  46: {
    sectionId: 12,
    helpInfo:
      'This NWP authorizes the construction, maintenance, or expansion of substation facilities (e.g., oil or natural gas or gaseous fuel custody transfer stations, boosting stations, compression stations, metering stations, pressure regulating stations) associated with an oil or natural gas pipeline in non-tidal waters of the United States, provided the activity, in combination with all other activities included in one single and complete project, does not result in the loss of greater than 1/2-acre of waters of the United States.',
    question: 'Will the project involve the construction of oil or natural gas substations?',
    questionTypeId: 5,
    parentQuestions: [
      getParentObjectV2(38, 5, '=', 'NO'),
      getParentObjectV2(41, 5, '=', 'NO'),
      getParentObjectV2(42, 7, '=', 'Not Applicable'),
      getParentObjectV2(43, 7, '=', 'Not Applicable'),
      getParentObjectV2(45, 5, '=', 'NO'),
    ],
    ...commonQuestionData,
  },
  47: {
    sectionId: 12,
    question:
      'Will the project involve the discharges of dredged or fill material into non-tidal wetlands adjacent to tidal waters of the United States to construct, maintain, or expand substation facilities?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(46, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  48: {
    sectionId: 12,
    question: 'Will the project involve the construction of foundations for above-ground oil or natural gas pipelines?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(46, 5, '=', 'NO'), getParentObjectV2(47, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  49: {
    sectionId: 12,
    helpInfo:
      'Access roads must be the minimum width necessary. Access roads must be constructed so that the length of the road minimizes any adverse effects on waters of the United States and must be as near as possible to pre-construction contours and elevations (e.g., at grade corduroy roads or geotextile/gravel roads). Access roads constructed above pre-construction contours and elevations in waters of the United States must be properly bridged or culverted to maintain surface flows.',
    question:
      'Will the project involve the construction of access roads for the construction and maintenance of oil or natural gas pipelines?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(48, 5, '=', 'YES'), getParentObjectV2(48, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  50: {
    sectionId: 12,
    question:
      'If the project is associated with the construction of access roads for construction or maintenance, will the project involve the discharges of dredged or fill material into non-tidal wetlands adjacent to tidal waters of the United States to construct the roads?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(49, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  51: {
    sectionId: 12,
    question:
      'Will the project involve temporary structures, fills, and work necessary for the remediation of inadvertent returns of drilling fluids to waters of the United States through sub-soil fissures or fractures that might occur during horizontal directional drilling activities conducted for the purpose of installing or replacing oil or natural gas pipelines?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(49, 5, '=', 'NO'), getParentObjectV2(50, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  52: {
    sectionId: 12,
    helpInfo:
      'Appropriate measures must be taken to maintain normal downstream flows and minimize flooding to the maximum extent practicable, when temporary structures, work, and discharges of dredged or fill material, including cofferdams, are necessary for construction activities, access fills, or dewatering of construction sites. Temporary fills must consist of materials, and be placed in a manner, that will not be eroded by expected high flows. After construction, temporary fills must be removed in their entirety and the affected areas returned to pre-construction elevations. The areas affected by temporary fills must be revegetated, as appropriate.',
    question:
      'Will the project involve temporary structures, fills, and work, including the use of temporary mats, necessary to conduct the oil or natural gas pipeline activity?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(51, 5, 'exists', '')],
    ...commonQuestionData,
  },
};
const nwp13QuestionsById: QuestionDataById = {
  53: {
    sectionId: 13,
    question:
      'Will the project involve bank stabilization activities necessary for erosion control or prevention, such as vegetative stabilization, bioengineering, sills, rip rap, revetment, gabion baskets, stream barbs, and bulkheads, or combinations of bank stabilization techniques?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '13'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  54: {
    sectionId: 13,
    question: 'Will material be placed in excess of what is needed for erosion protection?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(53, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  55: {
    sectionId: 13,
    question: 'Will the activity be more than 500 linear feet along the bank?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(54, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  56: {
    sectionId: 13,
    question:
      'Will the activity exceed an average of one cubic yard per running foot as measured along the length of the treated bank, below the plane of the ordinary high water mark or the high tide line?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(55, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  57: {
    sectionId: 13,
    helpInfo:
      'Special Aquatic Sites: Wetlands, mudflats, vegetated shallows, coral reefs, and riffle & pool complexes, sanctuaries, and refuges as defined at 40 CFR Part 230.40 through 230.45. These areas are generally recognized as significantly influencing or positively contributing to the general overall environmental health or vitality of the entire ecosystem of a region (40 CFR 230.3(m)).',
    question: 'Will the activity involve discharges of dredged or fill material into special aquatic sites?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(56, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  58: {
    sectionId: 13,
    question: 'Will material be a type or placed in a manner that will impair surface water flow?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(57, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  59: {
    sectionId: 13,
    question: 'Will material be placed in a manner that will be eroded by normal or expected high flows?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(58, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  60: {
    sectionId: 13,
    question:
      'Will native plants appropriate for current site conditions, including salinity, be used for bioengineering or vegetative bank stabilization?',
    questionTypeId: 7,
    parentQuestions: [getParentObjectV2(59, 5, '=', 'NO')],
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  61: {
    sectionId: 13,
    question: 'Is the activity a stream channelization activity?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(60, 7, '=', 'YES'), getParentObjectV2(60, 7, '=', 'Not Applicable')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  62: {
    sectionId: 13,
    helpInfo:
      'Appropriate measures must be taken to maintain normal downstream flows and minimize flooding to the maximum extent practicable, when temporary structures, work, and discharges of dredged or fill material, including cofferdams, are necessary for construction activities, access fills, or dewatering of construction sites. Temporary fills must consist of materials, and be placed in a manner, that will not be eroded by expected high flows. After construction, temporary fills must be removed in their entirety and the affected areas returned to pre-construction elevations. The areas affected by temporary fills must be revegetated, as appropriate.',
    question:
      'Will the project involve temporary structures, fills, and work, including the use of temporary mats, necessary to construct the bank stabilization project?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(61, 5, '=', 'NO')],
    ...commonQuestionData,
  },
};
const nwp14QuestionsById: QuestionDataById = {
  63: {
    sectionId: 14,
    question:
      'Will the project involve crossings of waters of the United States associated with the construction, expansion, modification, or improvement of linear transportation projects (e.g., roads, highways, railways, trails, driveways, airport runways, and taxiways) in waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '14'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  64: {
    sectionId: 14,
    question:
      'Will the discharge of dredged or fill material cause the loss of more than 0.1 acre of waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(63, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  65: {
    sectionId: 14,
    helpInfo:
      'Special Aquatic Sites: Wetlands, mudflats, vegetated shallows, coral reefs, and riffle & pool complexes, sanctuaries, and refuges as defined at 40 CFR Part 230.40 through 230.45. These areas are generally recognized as significantly influencing or positively contributing to the general overall environmental health or vitality of the entire ecosystem of a region (40 CFR 230.3(m)).',
    question:
      'Will the activity involve discharges of dredged or fill material into special aquatic sites, including wetlands?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(64, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  65.1: {
    sectionId: 14,
    question: 'Will the project involve any stream channel modification or bank stabilization?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(65, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  65.2: {
    sectionId: 14,
    question:
      'Will the stream channel modification or bank stabilization occur in the immediate vicinity of the project and be limited to the minimum amount necessary to construct or protect the linear transportation project?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(65.1, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  66: {
    sectionId: 14,
    helpInfo:
      'Appropriate measures must be taken to maintain normal downstream flows and minimize flooding to the maximum extent practicable, when temporary structures, work, and discharges of dredged or fill material, including cofferdams, are necessary for construction activities, access fills, or dewatering of construction sites. Temporary fills must consist of materials, and be placed in a manner, that will not be eroded by expected high flows. Temporary fills must be removed in their entirety and the affected areas returned to preconstruction elevations. The areas affected by temporary fills must be revegetated, as appropriate.',
    question:
      'Will the project involve temporary structures, fills, and work, including the use of temporary mats, necessary to construct the linear transportation project?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(65.1, 5, '=', 'NO'), getParentObjectV2(65.2, 5, '=', 'YES')],
    ...commonQuestionData,
  },
  67: {
    sectionId: 14,
    question:
      'Will the activity involve the construction of non-linear features commonly associated with transportation projects, such as vehicle maintenance or storage buildings, parking lots, train stations, or aircraft hangars?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(66, 5, 'exists', '')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp15QuestionsById: QuestionDataById = {
  68: {
    sectionId: 15,
    question:
      'Will the project involve the discharges of dredged or fill material incidental to the construction of a bridge across navigable waters of the United States, including cofferdams, abutments, foundation seals, piers, and temporary construction and access fills, provided the construction of the bridge structure has been authorized by the U.S. Coast Guard under Section 9 of the Rivers and Harbors Act of 1899 or other applicable laws?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '15'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  69: {
    sectionId: 15,
    helpInfo: 'Causeways and approaches require a separate 404 permit.',
    question: 'Is the fill associated with causeways or approaches?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(68, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp16QuestionsById: QuestionDataById = {
  70: {
    sectionId: 16,
    helpInfo:
      'The return water from a contained disposal area is administratively defined as a discharge of dredged material by 33 CFR 323.2(d), even though the disposal itself occurs in an area that has no waters of the United States and does not require a Section 404 permit. This NWP satisfies the technical requirement for a Section 404 permit for the return water where the quality of the return water is controlled by the state through the Clean Water Act Section 401 certification procedures. The dredging activity may require a Section 404 permit (33 CFR 323.2(d)), and will require a Section 10 permit if located in navigable waters of the United States.',
    question: 'Will the project involve return water from an upland contained dredged material disposal area?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '16'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp18QuestionsById: QuestionDataById = {
  71: {
    sectionId: 17,
    question: 'Will the project involve minor discharges of dredged or fill material into waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '18'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  72: {
    sectionId: 17,
    question:
      'Will the discharge of dredged or fill material or the volume of area excavated exceed 10 cubic yards below the plane of the ordinary high water mark or the high tide line?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObjectV2(71, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  72.1: {
    sectionId: 17,
    question:
      'Will the discharge of dredged or fill material cause the loss of more than 1/10 acre of waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(72, 7, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  72.2: {
    sectionId: 17,
    question: 'Will the discharge of dredged or fill material be placed for the purpose of stream diversion?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(72.1, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  73: {
    sectionId: 17,
    helpInfo:
      'Special Aquatic Sites: Wetlands, mudflats, vegetated shallows, coral reefs, and riffle & pool complexes, sanctuaries, and refuges as defined at 40 CFR Part 230.40 through 230.45. These areas are generally recognized as significantly influencing or positively contributing to the general overall environmental health or vitality of the entire ecosystem of a region (40 CFR 230.3(m)).',
    question:
      'Will the activity involve discharges of dredged or fill material into special aquatic sites, including wetlands?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(72, 7, '=', 'Not Applicable'), getParentObjectV2(72.2, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp19QuestionsById: QuestionDataById = {
  74: {
    sectionId: 18,
    helpInfo:
      'This NWP does not authorize the dredging or degradation through siltation of coral reefs, sites that support submerged aquatic vegetation (including sites where submerged aquatic vegetation is documented to exist but may not be present in a given year), anadromous fish spawning areas, or wetlands, or the connection of canals or other artificial waterways to navigable waters of the United States. All dredged material must be deposited and retained in an area that has no waters of the United States unless otherwise specifically approved by the district engineer under separate authorization.',
    question:
      'Will the project involve dredging of no more than 25 cubic yards below the plane of the ordinary high water mark or the mean high water mark from Section 10 waters?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '19'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  74.1: {
    sectionId: 18,
    question:
      'Will the project result in dredging or degradation through siltation of coral reefs, sites that support submerged aquatic vegetation (including sites where submerged aquatic vegetation is documented to exist but may not be present in a given year), anadromous fish spawning areas, or wetlands, or the connection of canals or other artificial waterways to navigable waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(74, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  74.2: {
    sectionId: 18,
    question:
      'Will all dredged material be deposited and retained in an area that has no waters of the United States unless otherwise specifically approved by the district engineer under separate authorization?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(74.1, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp20QuestionsById: QuestionDataById = {
  75: {
    sectionId: 19,
    helpInfo:
      "This NWP also authorizes activities required for the cleanup of oil releases in waters of the United States from electrical equipment that are governed by EPA's polychlorinated biphenyl spill response regulations at 40 CFR part 761. This NWP also authorizes the use of temporary structures and fills in waters of the U.S. for spill response training exercises.",
    question:
      'Will the project involve activities conducted in response to a discharge or release of oil or hazardous substances that are subject to the National Oil and Hazardous Substances Pollution Contingency Plan (40 CFR part 300) including containment, cleanup, and mitigation efforts, provided that the activities are done under either: (1) the Spill Control and Countermeasure Plan required by 40 CFR 112.3; (2) the direction or oversight of the federal on-scene coordinator designated by 40 CFR part 300; or (3) any approved existing state, regional or local contingency plan provided that the Regional Response Team (if one exists in the area) concurs with the proposed response efforts?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '20'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    ...commonQuestionData,
  },
  75.1: {
    sectionId: 19,
    question:
      "Will the project involve activities required for the cleanup of oil releases in waters of the United States from electrical equipment that are governed by EPA's polychlorinated biphenyl spill response regulations at 40 CFR part 761?",
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(75, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  75.2: {
    sectionId: 19,
    question:
      'Will the project involve the use of temporary structures and fills in waters of the United States for spill response training exercises?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(75.1, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp22QuestionsById: QuestionDataById = {
  76: {
    sectionId: 20,
    helpInfo: 'This NWP does not authorize maintenance dredging, shoal removal, or riverbank snagging.',
    question:
      'Will the project involve temporary structures or minor discharges of dredged or fill material required for the removal of wrecked, abandoned, or disabled vessels, or the removal of man-made obstructions to navigation?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '22'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  77: {
    sectionId: 20,
    question: 'Is the vessel listed or eligible for listing in the National Register of Historic Places?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(76, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  78: {
    sectionId: 20,
    helpInfo:
      'Special Aquatic Sites: Wetlands, mudflats, vegetated shallows, coral reefs, and riffle & pool complexes, sanctuaries, and refuges as defined at 40 CFR Part 230.40 through 230.45. These areas are generally recognized as significantly influencing or positively contributing to the general overall environmental health or vitality of the entire ecosystem of a region (40 CFR 230.3(m)).',
    question: 'Will the activity occur in a special aquatic site, including wetlands or coral reefs?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(77, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp23QuestionsById: QuestionDataById = {
  79: {
    sectionId: 21,
    question: `Will the project involve activities undertaken, assisted, authorized, regulated, funded, or financed, in whole or in part, by another Federal agency or department where:
            (a) That agency or department has determined, pursuant to the Council on Environmental Quality's implementing regulations for the National Environmental Policy Act (40 CFR part 1500 et seq.), that the activity is categorically excluded from the requirement to prepare an environmental impact statement or environmental assessment analysis, because it is included within a category of actions which neither individually nor cumulatively have a significant effect on the human environment; and
            (b) The Office of the Chief of Engineers (Attn: CECW-CO) has concurred with that agency's or department's determination that the activity is categorically excluded and approved the activity for authorization under NWP 23?`,
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '23'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  80: {
    sectionId: 21,
    helpInfo:
      'Activities in [RGL 05-07](https://usace.contentdm.oclc.org/utils/getfile/collection/p16021coll9/id/1272)(Approved CEs from BOR, FHWS, & USCG)',
    question: 'Is the activity listed in Regulatory Guidance Letter 05-07, under paragraph 3.b?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(79, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp24QuestionsById: QuestionDataById = {
  81: {
    sectionId: 22,
    helpInfo:
      'Those activities that do not involve an Indian Tribe or State Clean Water Act Section 404 permit are not included in this NWP, but certain structures will be exempted by Section 154 of Pub. L. 94-587, 90 Stat. 2917 (33 U.S.C. 591) (see 33 CFR 322.4(b)).',
    question:
      'Does the activity have a permit from a State or Indian Tribe administering its own Section 404 permit program pursuant to 33 U.S.C. 1344(g)-(l) but also requires a permit under Section 10 of the Rivers and Harbors Act of 1899?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '24'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp25QuestionsById: QuestionDataById = {
  82: {
    sectionId: 23,
    helpInfo:
      'This NWP does not authorize filled structural members that would support buildings, building pads, homes, house pads, parking areas, storage areas and other such structures. The structure itself may require a separate Section 10 permit if located in navigable waters of the United States.',
    question:
      'Will the project involve discharges of dredged or fill material such as concrete, sand, rock, etc., into tightly sealed forms or cells where the material will be used as a structural member for standard pile supported structures, such as bridges, transmission line footings, and walkways, or for general navigation, such as mooring cells, including the excavation of bottom material from within the form prior to the discharge of concrete, sand, rock, etc?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '25'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  82.1: {
    sectionId: 23,
    question:
      'Will the project involve filled structural members that would support buildings, building pads, homes, house pads, parking areas, storage areas and other such structures?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(82, 5, '=', 'YES')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  82.2: {
    sectionId: 23,
    question:
      'If your project involves work in Section 10 waters, is that work covered under an existing USACE general or individual permit?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(82.1, 5, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp28QuestionsById: QuestionDataById = {
  83: {
    sectionId: 24,
    helpInfo:
      'No dredging, additional slips, dock spaces, or expansion of any kind within waters of the United States is authorized by this NWP.',
    question:
      'Will the project involve the reconfiguration of existing docking facilities within an authorized marina area?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '28'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  83.1: {
    sectionId: 24,
    question: 'Will the project involve dredging, additional slips, dock spaces, or expansion of the marina?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(83, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp30QuestionsById: QuestionDataById = {
  84: {
    sectionId: 25,
    helpInfo:
      'Such activities include, but are not limited to, plowing or discing to impede succession, preparing seed beds, or establishing fire breaks.',
    question:
      'Will the project involve discharges of dredged or fill material into nontidal waters of the United States and maintenance activities that are associated with moist soil management for wildlife for the purpose of continuing ongoing, site-specific, wildlife management activities where soil manipulation is used to manage habitat and feeding areas for wildlife?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '30'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  84.1: {
    sectionId: 25,
    question:
      'Will sufficient riparian areas must be maintained adjacent to all open water bodies, including streams, to preclude water quality degradation due to erosion and sedimentation?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(84, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  84.2: {
    sectionId: 25,
    question: 'Does your project involve work in Section 10 waters?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(84.1, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  85: {
    sectionId: 25,
    question:
      'Will the activity involve the construction of new dikes, roads, water control structures, or similar features associated with the management areas?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(84.2, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  86: {
    sectionId: 25,
    question: 'Will the activity convert wetlands to uplands, impoundments, or other open water bodies?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(85, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp33QuestionsById: QuestionDataById = {
  87: {
    sectionId: 26,
    helpInfo:
      'The use of dredged material may be allowed if the district engineer determines that it will not cause more than minimal adverse environmental effects. This permit does not authorize the use of cofferdams to dewater wetlands or other aquatic areas to change their use. Structures left in place after construction is completed require a separate Section 10 permit if located in navigable waters of the United States.',
    question:
      'Will the project involve the placement of temporary structures, work, and discharges of dredged or fill material, including cofferdams, necessary for construction activities or access fills or dewatering of construction sites, provided that the associated primary activity is authorized by the USACE or U.S. Coast Guard?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '33'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    ...commonQuestionData,
  },
  88: {
    sectionId: 26,
    question:
      'Will the project involve the placement of temporary structures, work, and discharges of dredged or fill material, including cofferdams, necessary for construction activities not otherwise subject to the USACE or U.S. Coast Guard permit requirements?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(87, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  89: {
    sectionId: 26,
    question: 'Will appropriate measures be taken to maintain near normal downstream flows and to minimize flooding?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(87, 5, '=', 'YES'), getParentObjectV2(88, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  90: {
    sectionId: 26,
    question: 'Will fill material be placed in a manner that will not be eroded by expected high flows?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(89, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  91: {
    sectionId: 26,
    helpInfo: 'The affected areas must also be revegetated, as appropriate.',
    question:
      'Following completion of construction, will temporary fill be entirely removed to an area that has no waters of the United States, dredged material returned to its original location, and the affected areas restored to pre-construction elevations?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(90, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  91.1: {
    sectionId: 26,
    question: 'Will the project dewater wetlands or other aquatic sites to change their use?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(91, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  92: {
    sectionId: 26,
    question: 'Will the project be conducted in a navigable water of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(91.1, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp35QuestionsById: QuestionDataById = {
  93: {
    sectionId: 27,
    helpInfo:
      'All dredged material must be deposited and retained in an area that has no waters of the United States unless otherwise specifically approved by the district engineer under separate authorization. Proper sediment controls must be used for the disposal site.',
    question:
      'Will the project involve the removal of accumulated sediment for maintenance of existing marina basins, access channels to marinas or boat slips, and boat slips to previously authorized depths or controlling depths for ingress/egress, whichever is less?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '35'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  93.1: {
    sectionId: 27,
    question:
      'Will dredged material be deposited in an area that has no waters of the United States or area that has specifically been approved by the District Engineer under separate authorization?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(93, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp36QuestionsById: QuestionDataById = {
  94: {
    sectionId: 28,
    question: 'Will the project involve the construction, repair, or replacement of boat ramps?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '36'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  95: {
    sectionId: 28,
    question: 'Will the discharge of fill material be 50 cubic yards or less?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(94, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  96: {
    sectionId: 28,
    question: 'Will the boat ramp be 20 feet in width or less?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(95, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  97: {
    sectionId: 28,
    question: 'Will the base material consist of crushed stone, gravel or other suitable materials?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(96, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  98: {
    sectionId: 28,
    question:
      'If excavation is required for the installation of the boat ramp, will the excavation be limited to the area necessary for site preparation and all excavated material be removed to an area that has no waters of the United States?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObjectV2(97, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  99: {
    sectionId: 28,
    helpInfo:
      'Special Aquatic Sites: Wetlands, mudflats, vegetated shallows, coral reefs, and riffle & pool complexes, sanctuaries, and refuges as defined at 40 CFR Part 230.40 through 230.45. These areas are generally recognized as significantly influencing or positively contributing to the general overall environmental health or vitality of the entire ecosystem of a region (40 CFR 230.3(m)).',
    question: 'Will fill material be placed in a special aquatic site?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(98, 7, '!=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  99.1: {
    sectionId: 28,
    question:
      'If the project involves dredging in Section 10 waters to provide access to the boat ramp, is such dredging covered under an existing general or individual permit?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(99, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp41QuestionsById: QuestionDataById = {
  100: {
    sectionId: 29,
    helpInfo:
      'The reshaping of the drainage ditch cannot increase drainage capacity beyond the original as-built capacity nor can it expand the area drained by the drainage ditch as originally constructed (i.e., the capacity of the drainage ditch must be the same as originally constructed and it cannot drain additional wetlands or other waters of the United States). This NWP does not authorize the relocation of drainage or irrigation ditches constructed in waters of the United States; the location of the centerline of the reshaped drainage or irrigation ditch must be approximately the same as the location of the centerline of the original drainage or irrigation ditch. This NWP does not authorize stream channelization or stream relocation projects.',
    question:
      'Will the project involve discharges of dredged or fill material into non-tidal waters of the United States, excluding non-tidal wetlands adjacent to tidal waters, to modify the cross-sectional configuration of currently serviceable drainage and irrigation ditches constructed in waters of the United States, for the purpose of improving water quality by regrading the drainage or irrigation ditch with gentler slopes, which can reduce erosion, increase growth of vegetation, and increase uptake of nutrients and other substances by vegetation?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '41'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  100.1: {
    sectionId: 29,
    helpInfo:
      'The reshaping of the drainage ditch cannot increase drainage capacity beyond the original as-built capacity nor can it expand the area drained by the drainage ditch as originally constructed (i.e., the capacity of the drainage ditch must be the same as originally constructed and it cannot drain additional wetlands or other waters of the United States).',
    question:
      'Will the project involve increasing the drainage capacity beyond the original as-built capacity and/or expanding the area drained by the drainage ditch as originally constructed?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(100, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  100.2: {
    sectionId: 29,
    helpInfo:
      'This NWP does not authorize the relocation of drainage or irrigation ditches constructed in waters of the United States; the location of the centerline of the reshaped drainage or irrigation ditch must be approximately the same as the location of the centerline of the original drainage or irrigation ditch.',
    question:
      'Will the project involve relocation of drainage or irrigation ditches constructed in waters of the United States and/or stream channelization or stream relocation?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(100.1, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp43QuestionsById: QuestionDataById = {
  101: {
    sectionId: 30,
    helpInfo:
      'This NWP authorizes, to the extent that a Section 404 permit is required, discharges of dredged or fill material into non-tidal waters of the United States for the maintenance of stormwater management facilities, low impact development integrated management features, and pollutant reduction nature based solutions. The maintenance of stormwater management facilities, low impact development integrated management features, and pollutant reduction nature based solutions that are not waters of the United States does not require a Section 404 permit.',
    question:
      'Will the project involve discharges of dredged or fill material into nontidal waters of the United States for the construction of stormwater management facilities, including stormwater detention basins and retention basins and other stormwater management facilities; the construction of water control structures, outfall structures and emergency spillways; the construction of low impact development integrated management features such as bioretention facilities (e.g., rain gardens), vegetated filter strips, grassed swales, and infiltration trenches; and the construction of pollutant reduction nature based solutions designed to reduce inputs of sediments, nutrients, and other pollutants into waters, such as features needed to meet reduction targets established under Total Maximum Daily Loads set under the Clean Water Act?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '43'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  102: {
    sectionId: 30,
    question:
      'Will the project involve discharges of dredged or fill material into non-tidal waters of the United States for the construction of new stormwater management facilities or pollutant reduction nature based solutions, or the expansion of existing stormwater management facilities or pollutant reduction nature based solutions?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(101, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  102.1: {
    sectionId: 30,
    question:
      'Will the project involve maintenance activities limited to restoring the original design capacities of the stormwater management facility or pollutant reduction nature based solutions?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(102, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  102.2: {
    sectionId: 30,
    question:
      'Will the project involve discharges of dredged or fill material into non-tidal wetlands adjacent to tidal waters and/or for the construction of new stormwater management facilities in perennial streams?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(102.1, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp48QuestionsById: QuestionDataById = {
  103: {
    sectionId: 31,
    helpInfo:
      'For the purposes of this NWP, the project area is the area in which the operator is authorized to conduct commercial shellfish mariculture activities, as identified through a lease or permit issued by an appropriate state or local government agency, a treaty, or any easement, lease, deed, contract, or other legally binding agreement that establishes an enforceable property interest for the operator. This NWP authorizes the installation of buoys, floats, racks, trays, nets, lines, tubes, containers, and other structures into navigable waters of the United States. This NWP also authorizes discharges of dredged or fill material into waters of the United States necessary for shellfish seeding, rearing, cultivating, transplanting, and harvesting activities. Rafts and other floating structures must be securely anchored and clearly marked.',
    question:
      'Will the project involve structures or work in navigable waters of the United States and discharges of dredged or fill material into waters of the United States necessary for new and continuing commercial shellfish mariculture operations (i.e., the cultivation of bivalve molluscs such as oysters, mussels, clams, and scallops) in authorized project areas?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '48'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  104: {
    sectionId: 31,
    question: 'Will the project involve impacts to more than 1/2 acre of submerged aquatic vegetation?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(103, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  104.1: {
    sectionId: 31,
    question:
      'Will the project directly affect more than 1⁄2 acre of submerged aquatic vegetation beds in project areas that have not been used for commercial shellfish aquaculture activities during the past 100 years?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(104, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  105: {
    sectionId: 31,
    question:
      'Will the project involve the cultivation of a nonindigenous species in a waterbody not previously used for this purpose?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(104.1, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  106: {
    sectionId: 31,
    question:
      'Will the project involve the cultivation of an aquatic nuisance species as defined in the Nonindigenous Aquatic Nuisance Prevention and Control Act of 1990?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(105, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  107: {
    sectionId: 31,
    question:
      'Will the project involve attendant features such as docks, piers, boat ramps, stockpiles, or staging areas, or the deposition of shell material back into waters of the United States as waste?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(106, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp51QuestionsById: QuestionDataById = {
  108: {
    sectionId: 32,
    helpInfo:
      'Such facilities include infrastructure to collect solar (concentrating solar power and photovoltaic), wind, biomass, or geothermal energy. Attendant features may include, but are not limited to roads, parking lots, and stormwater management facilities within the land-based renewable energy generation facility.',
    question:
      'Will the project involve discharges of dredged or fill material into non-tidal waters of the United States for the construction, expansion, or modification of land-based renewable energy production facilities, including attendant features?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '51'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  108.1: {
    sectionId: 32,
    helpInfo:
      'If the only activities associated with the construction, expansion, or modification of a land-based renewable energy generation facility that require Department of the Army authorization are discharges of dredged or fill material into waters of the United States to construct, maintain, repair, and/or remove electric utility lines and/or road crossings, then NWP 57 and/or NWP 14 shall be used if those activities meet the terms and conditions of NWPs 57 and 14, including any applicable regional conditions and any case-specific conditions imposed by the district engineer.',
    question:
      'Will the project involve only the construction, maintainance, repair, and/or removal of electric utility lines and/or road crossings?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(108, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  108.2: {
    sectionId: 32,
    question:
      'Will the project involve the discharge of dredge or fill material into non-tidal wetlands adjacent to tidal waters?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(108.1, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  109: {
    sectionId: 32,
    question: 'Will the project involve the loss of more than 1/10-acre of waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(108.2, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};
const nwp57QuestionsById: QuestionDataById = {
  110: {
    sectionId: 33,
    helpInfo:
      'This NWP authorizes discharges of dredged or fill material into waters of the United States and structures or work in navigable waters for crossings of those waters associated with the construction, maintenance, or repair of electric utility lines and telecommunication lines. There must be no change in pre-construction contours of waters of the United States. An "electric utility line and telecommunication line" is defined as any cable, line, fiber optic line, or wire for the transmission for any purpose of electrical energy, telephone, and telegraph messages, and internet, radio, and television communication.',
    question:
      'Will the project involve activities required for the construction, maintenance, repair, and removal of electric utility lines, telecommunication lines, and associated facilities in waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '57'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  111: {
    sectionId: 33,
    question: 'Will losses of waters of the United States exceed 1/10 acre?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(110, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  112: {
    sectionId: 33,
    question:
      'Will the project involve work in, over or under Navigable Waters of the United States subject to Section 10 of the Rivers and Harbor Act?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(111, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  113: {
    sectionId: 33,
    question:
      'Will the project require the construction of a utility line trench where material is sidecast into waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(112, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  114: {
    sectionId: 33,
    helpInfo:
      'In wetlands, the top 6 to 12 inches of the trench should normally be backfilled with topsoil from the trench.',
    question: 'Will material sidecast into waters of the United States be removed within 3 months of placement?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(113, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  115: {
    sectionId: 33,
    helpInfo:
      'Any exposed slopes and stream banks must be stabilized immediately upon completion of the utility line crossing of each waterbody.',
    question:
      'Will the project involve a trench constructed or backfilled in a manner that drains waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(113, 5, '=', 'NO'), getParentObjectV2(114, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  115.1: {
    sectionId: 33,
    question: 'Will the utility line result in changes to pre-construction contours of waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(115, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  116: {
    sectionId: 33,
    helpInfo:
      'This NWP authorizes the construction, maintenance, or expansion of substation facilities associated with an electric utility line or telecommunication line in non-tidal waters of the United States, provided the activity, in combination with all other activities included in one single and complete project, does not result in the loss of greater than 1/2-acre of waters of the United States. This NWP does not authorize discharges of dredged or fill material into non-tidal wetlands adjacent to tidal waters of the United States to construct, maintain, or expand substation facilities.',
    question:
      'Will the project involve the construction of a substation associated with an electric utility or telecommunication line?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(115.1, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  116.1: {
    sectionId: 33,
    question:
      'Will the substation involve the discharge of dredged or fill material into non-tidal wetlands adjacent to tidal waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(116, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  117: {
    sectionId: 33,
    helpInfo:
      'This NWP authorizes the construction or maintenance of foundations for overhead electric utility line or telecommunication line towers, poles, and anchors in all waters of the United States, provided the foundations are the minimum size necessary and separate footings for each tower leg (rather than a larger single pad) are used where feasible.',
    question:
      'Will the project involve the construction of foundations for overhead electric utility lines or telecommunication line towers, poles, and/or anchors?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(116, 5, '=', 'NO'), getParentObjectV2(116.1, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  118: {
    sectionId: 33,
    helpInfo:
      'Access roads must be the minimum width necessary. Access roads must be constructed so that the length of the road minimizes any adverse effects on waters of the United States and must be as near as possible to pre-construction contours and elevations (e.g., at grade corduroy roads or geotextile/gravel roads). Access roads constructed above pre-construction contours and elevations in waters of the United States must be properly bridged or culverted to maintain surface flows.',
    question:
      'Will the project involve the construction of access roads for the construction and/or maintenance of electric utility lines or telecommunication lines, including overhead lines and substations?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(117, 5, 'exists', '')],
    ...commonQuestionData,
  },
  119: {
    sectionId: 33,
    question:
      'Will the construction or maintenance of access roads project involve the discharges of dredged or fill material into non-tidal wetlands adjacent to tidal waters of the United States to construct the roads?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(118, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  120: {
    sectionId: 33,
    helpInfo:
      'Appropriate measures must be taken to maintain normal downstream flows and minimize flooding to the maximum extent practicable, when temporary structures, work, and discharges of dredged or fill material, including cofferdams, are necessary for construction activities, access fills, or dewatering of construction sites. Temporary fills must consist of materials, and be placed in a manner, that will not be eroded by expected high flows. After construction, temporary fills must be removed in their entirety and the affected areas returned to pre-construction elevations. The areas affected by temporary fills must be revegetated, as appropriate.',
    question:
      'Will the project involve temporary structures, fills, and work necessary to conduct the electric utility line activity?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(118, 5, '=', 'NO'), getParentObjectV2(119, 5, '=', 'NO')],
    ...commonQuestionData,
  },
};
const nwp58QuestionsById: QuestionDataById = {
  121: {
    sectionId: 34,
    helpInfo:
      'This NWP authorizes discharges of dredged or fill material into waters of the United States and structures or work in navigable waters for crossings of those waters associated with the construction, maintenance, or repair of utility lines for water and other substances, including outfall and intake structures. There must be no change in pre-construction contours of waters of the United States. A "utility line" is defined as any pipe or pipeline for the transportation of any gaseous, liquid, liquescent, or slurry substance, for any purpose that is not oil, natural gas, or petrochemicals. Examples of activities authorized by this NWP include utility lines that convey water, sewage, 43 stormwater, wastewater, brine, irrigation water, and industrial products that are not petrochemicals. The term "utility line" does not include activities that drain a water of the United States, such as drainage tile or french drains, but it does apply to pipes conveying drainage from another area.',
    question:
      'Will the project involve activities required for the construction, maintenance, repair, and removal of utility lines for water and other substances, excluding oil, natural gas, products derived from oil or natural gas, and electricity?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '58'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  122: {
    sectionId: 34,
    question: 'Will impacts to waters of the United States be over 1/10 acre?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(121, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  123: {
    sectionId: 34,
    question:
      'Will the project involve work in, over or under Navigable Waters of the United States subject to Section 10 of the Rivers and Harbor Act?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(122, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  124: {
    sectionId: 34,
    question:
      'Will the project require the construction of a utility line trench where material is sidecast into waters of the United States',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(123, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  125: {
    sectionId: 34,
    helpInfo:
      'In wetlands, the top 6 to 12 inches of the trench should normally be backfilled with topsoil from the trench.',
    question: 'Will material sidecast into waters of the United States be removed within 3 months of placement?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(124, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  126: {
    sectionId: 34,
    helpInfo:
      'Any exposed slopes and stream banks must be stabilized immediately upon completion of the utility line crossing of each waterbody.',
    question: 'Will the trench be constructed or backfilled in a manner that drains waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(125, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  126.1: {
    sectionId: 34,
    question:
      'Will the construction of the utility line result in changes to pre-construction contours of waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(126, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  127: {
    sectionId: 34,
    helpInfo:
      'This NWP authorizes the construction, maintenance, or expansion of substation facilities associated with a utility line in non-tidal waters of the United States, provided the activity, in combination with all other activities included in one single and complete project, does not result in the loss of greater than 1/2-acre of waters of the United States. This NWP does not authorize discharges of dredged or fill material into non-tidal wetlands adjacent to tidal waters of the United States to construct, maintain, or expand substation facilities.',
    question: 'Will the project involve the construction of an utility line substation?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(124, 5, '=', 'NO'), getParentObjectV2(126.1, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  127.1: {
    sectionId: 34,
    question:
      'Will the substation involve the discharge of dredged or fill material into non-tidal wetlands adjacent to tidal waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(127, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  128: {
    sectionId: 34,
    helpInfo:
      'This NWP authorizes the construction or maintenance of foundations for above-ground utility lines in all waters of the United States, provided the foundations are the minimum size necessary.',
    question:
      'Will the project involve the construction or maintenance of foundations associated with above ground utility lines?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(127, 5, '=', 'NO'), getParentObjectV2(127.1, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  129: {
    sectionId: 34,
    helpInfo:
      'Access roads must be the minimum width necessary. Access roads must be constructed so that the length of the road minimizes any adverse effects on waters of the United States and must be as near as possible to pre-construction contours and elevations (e.g., at grade corduroy roads or geotextile/gravel roads). Access roads constructed above pre-construction contours and elevations in waters of the United States must be properly bridged or culverted to maintain surface flows.',
    question:
      'Will the project involve the construction of access roads for the construction and maintenance of utility lines?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(128, 5, 'exists', '')],
    ...commonQuestionData,
  },
  130: {
    sectionId: 34,
    question:
      'Will the construction and/or maintenance of access roads involve the discharges of dredged or fill material into non-tidal wetlands adjacent to tidal waters of the United States to construct the roads?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(129, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  131: {
    sectionId: 34,
    helpInfo:
      'Appropriate measures must be taken to maintain normal downstream flows and minimize flooding to the maximum extent practicable, when temporary structures, work, and discharges of dredged or fill material, including cofferdams, are necessary for construction activities, access fills, or dewatering of construction sites. Temporary fills must consist of materials, and be placed in a manner, that will not be eroded by expected high flows. After construction, temporary fills must be removed in their entirety and the affected areas returned to pre-construction elevations. The areas affected by temporary fills must be revegetated, as appropriate.',
    question:
      'Will the project involve temporary structures, fills, and work necessary to conduct the utility line activity?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(129, 5, '=', 'NO'), getParentObjectV2(130, 5, '=', 'NO')],
    ...commonQuestionData,
  },
};
const nwp60QuestionsById: QuestionDataById = {
  132: {
    sectionId: 35,
    question:
      'Will the project involve discharges for purposes of restoring and/or enhancing the ability of fish and other aquatic organisms to move through aquatic ecosystems for activities including, but not limited to, the construction, maintenance, modification, or expansion of conventional/technical and nature-like fishways; the construction, maintenance, modification, or expansion of fish bypass channels around existing in-stream structures; the replacement of existing structures (e.g. culverts, low-water crossings) with structures planned, designed, and constructed to restore or enhance passage of fish and other aquatic organisms; the installation of fish screens and other devices to minimize entrainment and entrapment of fish and other aquatic organisms in irrigation ditches and other features; devices to guide fish and other aquatic organisms through passage features; fish lifts and fish by-pass pipes; the modification of existing in-stream structures, such as dams or weirs, to improve the ability of fish and other aquatic organisms to move past those structures?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(1, 7, '=', '60'), getParentObjectV2(10.1, 7, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  132.1: {
    sectionId: 35,
    question: 'Will the project involve dam removal activities?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(132, 5, '=', 'YES')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  132.2: {
    sectionId: 35,
    question:
      'Will the project involve discharges that result in the loss of waters of the United States exceeding 1 acre?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(132.1, 5, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  132.3: {
    sectionId: 35,
    question: 'Will the project involve the loss of more than 1/10-acre of waters of the United States?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(132.2, 5, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  132.4: {
    sectionId: 35,
    question:
      'Will the project involve installation of new culverts at crossings of waterbodies where there are not existing culverts?',
    questionTypeId: 5,
    parentQuestions: [getParentObjectV2(132.3, 5, '=', 'NO')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};

export const nwpQuestions = {
  nonPcnQuestions: [nonPcnQuestionsById[1]],
  nwpGeneralQuestions: [
    nwpGeneralQuestionsById[1.1],
    nwpGeneralQuestionsById[2],
    nwpGeneralQuestionsById[3],
    nwpGeneralQuestionsById[4],
    nwpGeneralQuestionsById[4.1],
    nwpGeneralQuestionsById[5],
    nwpGeneralQuestionsById[5.1],
    nwpGeneralQuestionsById[6],
    nwpGeneralQuestionsById[8],
    nwpGeneralQuestionsById[9],
    nwpGeneralQuestionsById[10],
    nwpGeneralQuestionsById[10.1],
  ],
  nwp1Questions: [nwp1QuestionsById[11]],
  nwp2Questions: [nwp2QuestionsById[12]],
  nwp3Questions: [
    nwp3QuestionsById[13],
    nwp3QuestionsById[13.1],
    nwp3QuestionsById[13.2],
    nwp3QuestionsById[14],
    nwp3QuestionsById[15],
    nwp3QuestionsById[16],
    nwp3QuestionsById[17],
    nwp3QuestionsById[18],
    nwp3QuestionsById[18.1],
  ],
  nwp4Questions: [nwp4QuestionsById[19], nwp4QuestionsById[19.1]],
  nwp5Questions: [nwp5QuestionsById[20], nwp5QuestionsById[21], nwp5QuestionsById[22], nwp5QuestionsById[23]],
  nwp6Questions: [
    nwp6QuestionsById[24],
    nwp6QuestionsById[25],
    nwp6QuestionsById[25.1],
    nwp6QuestionsById[26],
    nwp6QuestionsById[27],
    nwp6QuestionsById[28],
    nwp6QuestionsById[29],
    nwp6QuestionsById[30],
    nwp6QuestionsById[31],
    nwp6QuestionsById[32],
    nwp6QuestionsById[33],
  ],
  nwp9Questions: [nwp9QuestionsById[34]],
  nwp10Questions: [nwp10QuestionsById[35]],
  nwp11Questions: [nwp11QuestionsById[36], nwp11QuestionsById[37]],
  nwp12Questions: [
    nwp12QuestionsById[38],
    nwp12QuestionsById[39],
    nwp12QuestionsById[40],
    nwp12QuestionsById[41],
    nwp12QuestionsById[41.1],
    nwp12QuestionsById[42],
    nwp12QuestionsById[43],
    nwp12QuestionsById[44],
    nwp12QuestionsById[45],
    nwp12QuestionsById[46],
    nwp12QuestionsById[47],
    nwp12QuestionsById[48],
    nwp12QuestionsById[49],
    nwp12QuestionsById[50],
    nwp12QuestionsById[51],
    nwp12QuestionsById[52],
  ],
  nwp13Questions: [
    nwp13QuestionsById[53],
    nwp13QuestionsById[54],
    nwp13QuestionsById[55],
    nwp13QuestionsById[56],
    nwp13QuestionsById[57],
    nwp13QuestionsById[58],
    nwp13QuestionsById[59],
    nwp13QuestionsById[60],
    nwp13QuestionsById[61],
    nwp13QuestionsById[62],
  ],
  nwp14Questions: [
    nwp14QuestionsById[63],
    nwp14QuestionsById[64],
    nwp14QuestionsById[65],
    nwp14QuestionsById[65.1],
    nwp14QuestionsById[65.2],
    nwp14QuestionsById[66],
    nwp14QuestionsById[67],
  ],
  nwp15Questions: [nwp15QuestionsById[68], nwp15QuestionsById[69]],
  nwp16Questions: [nwp16QuestionsById[70]],
  nwp18Questions: [
    nwp18QuestionsById[71],
    nwp18QuestionsById[72],
    nwp18QuestionsById[72.1],
    nwp18QuestionsById[72.2],
    nwp18QuestionsById[73],
  ],
  nwp19Questions: [nwp19QuestionsById[74], nwp19QuestionsById[74.1], nwp19QuestionsById[74.2]],
  nwp20Questions: [nwp20QuestionsById[75], nwp20QuestionsById[75.1], nwp20QuestionsById[75.2]],
  nwp22Questions: [nwp22QuestionsById[76], nwp22QuestionsById[77], nwp22QuestionsById[78]],
  nwp23Questions: [nwp23QuestionsById[79], nwp23QuestionsById[80]],
  nwp24Questions: [nwp24QuestionsById[81]],
  nwp25Questions: [nwp25QuestionsById[82], nwp25QuestionsById[82.1], nwp25QuestionsById[82.2]],
  nwp28Questions: [nwp28QuestionsById[83], nwp28QuestionsById[83.1]],
  nwp30Questions: [
    nwp30QuestionsById[84],
    nwp30QuestionsById[84.1],
    nwp30QuestionsById[84.2],
    nwp30QuestionsById[85],
    nwp30QuestionsById[86],
  ],
  nwp33Questions: [
    nwp33QuestionsById[87],
    nwp33QuestionsById[88],
    nwp33QuestionsById[89],
    nwp33QuestionsById[90],
    nwp33QuestionsById[91],
    nwp33QuestionsById[91.1],
    nwp33QuestionsById[92],
  ],
  nwp35Questions: [nwp35QuestionsById[93], nwp35QuestionsById[93.1]],
  nwp36Questions: [
    nwp36QuestionsById[94],
    nwp36QuestionsById[95],
    nwp36QuestionsById[96],
    nwp36QuestionsById[97],
    nwp36QuestionsById[98],
    nwp36QuestionsById[99],
    nwp36QuestionsById[99.1],
  ],
  nwp41Questions: [nwp41QuestionsById[100], nwp41QuestionsById[100.1], nwp41QuestionsById[100.2]],
  nwp43Questions: [
    nwp43QuestionsById[101],
    nwp43QuestionsById[102],
    nwp43QuestionsById[102.1],
    nwp43QuestionsById[102.2],
  ],
  nwp48Questions: [
    nwp48QuestionsById[103],
    nwp48QuestionsById[104],
    nwp48QuestionsById[104.1],
    nwp48QuestionsById[105],
    nwp48QuestionsById[106],
    nwp48QuestionsById[107],
  ],
  nwp51Questions: [
    nwp51QuestionsById[108],
    nwp51QuestionsById[108.1],
    nwp51QuestionsById[108.2],
    nwp51QuestionsById[109],
  ],
  nwp57Questions: [
    nwp57QuestionsById[110],
    nwp57QuestionsById[111],
    nwp57QuestionsById[112],
    nwp57QuestionsById[113],
    nwp57QuestionsById[114],
    nwp57QuestionsById[115],
    nwp57QuestionsById[115.1],
    nwp57QuestionsById[116],
    nwp57QuestionsById[116.1],
    nwp57QuestionsById[117],
    nwp57QuestionsById[118],
    nwp57QuestionsById[119],
    nwp57QuestionsById[120],
  ],
  nwp58Questions: [
    nwp58QuestionsById[121],
    nwp58QuestionsById[122],
    nwp58QuestionsById[123],
    nwp58QuestionsById[124],
    nwp58QuestionsById[125],
    nwp58QuestionsById[126],
    nwp58QuestionsById[126.1],
    nwp58QuestionsById[127],
    nwp58QuestionsById[127.1],
    nwp58QuestionsById[128],
    nwp58QuestionsById[129],
    nwp58QuestionsById[130],
    nwp58QuestionsById[131],
  ],
  nwp60Questions: [
    nwp60QuestionsById[132],
    nwp60QuestionsById[132.1],
    nwp60QuestionsById[132.2],
    nwp60QuestionsById[132.3],
    nwp60QuestionsById[132.4],
  ],
};

export const nwpQuestionsById = {
  ...nonPcnQuestionsById,
  ...nwpGeneralQuestionsById,
  ...nwp1QuestionsById,
  ...nwp2QuestionsById,
  ...nwp3QuestionsById,
  ...nwp4QuestionsById,
  ...nwp5QuestionsById,
  ...nwp6QuestionsById,
  ...nwp9QuestionsById,
  ...nwp10QuestionsById,
  ...nwp11QuestionsById,
  ...nwp12QuestionsById,
  ...nwp13QuestionsById,
  ...nwp14QuestionsById,
  ...nwp15QuestionsById,
  ...nwp16QuestionsById,
  ...nwp18QuestionsById,
  ...nwp19QuestionsById,
  ...nwp20QuestionsById,
  ...nwp22QuestionsById,
  ...nwp23QuestionsById,
  ...nwp24QuestionsById,
  ...nwp25QuestionsById,
  ...nwp28QuestionsById,
  ...nwp30QuestionsById,
  ...nwp33QuestionsById,
  ...nwp35QuestionsById,
  ...nwp36QuestionsById,
  ...nwp41QuestionsById,
  ...nwp43QuestionsById,
  ...nwp48QuestionsById,
  ...nwp51QuestionsById,
  ...nwp57QuestionsById,
  ...nwp58QuestionsById,
  ...nwp60QuestionsById,
};
